<template>
  <div class="index" v-loading="loading">
    <div class="index-con">
      <!-- <img class="index-img" src="@/assets/images/new-018.jpg" alt="" /> -->
      <div class="router">
        <span>IRADSTM</span> <b>→</b> <span>IDAST</span> <b>→</b><span>Fellow</span>
      </div>
      <div class="box-title-big">
        Founding Fellow
      </div>
      <div class="box-title">
        International Academy of Drying Science & Technology (IADST)
      </div>
      <div class="box">
        <el-table stripe :row-class-name="tableRowClassName" :data="list" class="gray-header" @cell-click="cellClick">
          <el-table-column type="index"> </el-table-column>
          <el-table-column prop="news_title_en" label="Name" width="360px"></el-table-column>
          <el-table-column prop="school_en" label="Institution"></el-table-column>
          <el-table-column prop="source_en" label="Country" width="130px"></el-table-column>
        </el-table>
        <div class="page">
          <el-pagination @current-change="pageFn" :page-size="pagesize" :current-page="page" background
            layout="prev, pager, next" :total="total"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.getjbList();
  },
  methods: {
    cellClick(row, column, cell, event) {
      this.$router.push({ path: "/FellowDetail?id=" + row.news_id });
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 1) {
        return "warning-row";
      } else if (rowIndex === 3) {
        return "success-row";
      }
    },
    pageFn(val) {
      console.log(val);
      this.page = val;
      this.getjbList();
    },
    getjbList() {
      this.loading = true;
      this.$http
        .jb_list({
          page: this.page,
          pagesize: this.pagesize,
          type_id: 832,
        })
        .then((res) => {
          this.loading = false;
          this.list = res.data;
          this.total = res.count;
          console.log(this.total);
        });
    },
  },
  data() {
    return {
      pagesize: 30,
      page: 1,
      total: 0,
      list: [],
      loading: false,
    };
  },
};
</script>

<style lang="less" scoped>
.gray-header {
  margin-top: 80px;
  cursor: pointer;

  .el-table__header-wrapper {
    background-color: #655f5f;
    /* 灰色的RBG值 */
  }
}

.page {
  display: flex;
  justify-content: center;
  padding: 30px 0;
}

.el-table .warning-row {
  background: #31a354;
}

.el-table .success-row {
  background: #f0f9eb;
}

.index-con {
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 50px;

  .text {
    font-size: 16px;
    line-height: 2;
  }

  .title {
    font-size: 24px;
    color: #5b965a;
    margin-bottom: 50px;
    font-weight: 700;
    font-family: Canaro, Arial, sans-serif;
  }

  .box-title-big {
    position: relative;
    padding-bottom: 10px;
    color: #5b965a;
    font-family: Canaro, Arial, sans-serif;
    font-size: 30px;
    line-height: 1.9;
    font-weight: 700;
    margin-bottom: 30px;
    text-align: center;

    &::before {
      content: "";
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 20%;
      max-width: 100%;
      height: 6px;
      background-color: #5b965a;

    }
  }

  .box-title {
    position: relative;
    padding-bottom: 10px;
    color: #5b965a;
    font-family: Canaro, Arial, sans-serif;
    font-size: 30px;
    line-height: 1.9;
    font-weight: 700;
    margin-bottom: 30px;
    text-align: center;

  }

  .router {
    display: flex;
    margin: 23px 0 31px;
    align-items: center;

    span {
      color: rgba(31, 31, 31, 0.5);
      font-family: Canaro, Arial, sans-serif;
      font-size: 11px;
      line-height: 1.8;
      font-weight: 400;
      white-space: nowrap;
      cursor: pointer;
    }

    b {
      color: #f9b033;
      font-weight: 400;
      margin: 0 10px;
    }

    span:nth-last-of-type(1) {
      color: #333;
    }
  }

  .index-img {
    width: 100%;
    height: auto;
  }
}

@media screen and (max-width: 768px) {

  .index-con {
    width: 100%;
    padding: 0 20px;

    .box-title-big {
      font-size: 20px;
    }

    .box-title {
      font-size: 18px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/fellow.vue